import { Link } from "react-router-dom";
import { Facebook, Instagram, Phone, Mail, MapPin, Clock } from "lucide-react";

const quickLinks = [
  { name: "Über uns", href: "/ueber-uns" },
  { name: "Produkte & Service", href: "/produkte-service" },
  { name: "Regionales", href: "/regionales" },
  { name: "Aktuelles", href: "/aktuelles" },
  { name: "Kontakt", href: "/kontakt" },
];

const legalLinks = [
  { name: "Impressum", href: "/impressum" },
  { name: "Datenschutz", href: "/datenschutz" },
  { name: "Barrierefreiheit", href: "/barrierefreiheit" },
];

export function Footer() {
  return (
    <footer className="bg-secondary border-t border-border" role="contentinfo">
      {/* Main Footer */}
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div className="text-center lg:text-left">
            <h3 className="text-lg font-heading font-semibold text-primary mb-6">
              REWE V. Gahndi
            </h3>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Dein REWE Markt in Flörsheim-Weilbach – Qualität, Frische und regionale Produkte 
              von lokalen Partnern. Wir freuen uns auf deinen Besuch!
            </p>
            {/* Social Links */}
            <div className="flex justify-center lg:justify-start gap-4 mt-6">
              <a
                href="https://www.facebook.com/people/Rewe-V-Gahndi/100063530618457/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-card border border-border hover:border-primary hover:text-primary transition-all duration-300"
                aria-label="Besuche uns auf Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/rewe_v._gahndi/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-card border border-border hover:border-primary hover:text-primary transition-all duration-300"
                aria-label="Besuche uns auf Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center lg:text-left">
            <h3 className="text-lg font-heading font-semibold text-primary mb-6">
              Schnellzugriff
            </h3>
            <nav aria-label="Footer Navigation">
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-muted-foreground hover:text-primary transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Opening Hours */}
          <div className="text-center lg:text-left">
            <h3 className="text-lg font-heading font-semibold text-primary mb-6">
              Öffnungszeiten
            </h3>
            <div className="flex flex-col items-center lg:flex-row lg:items-center lg:justify-start gap-2 lg:gap-3 text-muted-foreground">
              <Clock className="w-5 h-5 text-primary flex-shrink-0" />
              <div className="text-center lg:text-left">
                <p className="font-medium text-muted-foreground">Markt</p>
                <p>Mo. – Sa.: 7:00 – 22:00 Uhr</p>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="text-center lg:text-left">
            <h3 className="text-lg font-heading font-semibold text-primary mb-6">
              Kontakt
            </h3>
            <address className="not-italic space-y-4">
              <div className="flex flex-col items-center lg:flex-row lg:items-center lg:justify-start gap-2 lg:gap-3 text-muted-foreground">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0" />
                <div className="text-center lg:text-left">
                  <p>Industriestraße 40</p>
                  <p>65439 Flörsheim-Weilbach</p>
                </div>
              </div>
              <a
                href="tel:+496145321455"
                className="flex flex-col items-center lg:flex-row lg:items-center lg:justify-start gap-2 lg:gap-3 text-muted-foreground hover:text-primary transition-colors"
              >
                <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                <span>06145 321455</span>
              </a>
              <a
                href="mailto:vigheshan.gahndi@rewe-kaufleute.com"
                className="flex flex-col items-center lg:flex-row lg:items-start lg:justify-start gap-2 lg:gap-3 text-muted-foreground hover:text-primary transition-colors text-sm min-w-0"
              >
                <Mail className="w-5 h-5 text-primary flex-shrink-0 lg:mt-1" />
                <span className="text-xs sm:text-sm break-all">vigheshan.gahndi@rewe-kaufleute.com</span>
              </a>
            </address>
          </div>
        </div>
      </div>

      {/* Gold Line */}
      <div className="gold-line" />

      {/* Bottom Footer */}
      <div className="container-custom py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <div className="flex flex-wrap justify-center gap-4">
            {legalLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className="hover:text-primary transition-colors"
              >
                {link.name}
              </Link>
            ))}
          </div>
          <p className="text-center">
            Copyright by {new Date().getFullYear()} REWE Vigheshan Gahndi oHG | Powered by{" "}
            <a
              href="https://flh-mediadigital.de"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary underline underline-offset-4 hover:text-gold-light transition-colors"
            >
              FLH MEDIA DIGITAL
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
